import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from 'primeng/divider';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import {ImageModule} from 'primeng/image';
import { RippleModule } from 'primeng/ripple';
import { ChipModule } from 'primeng/chip';
import { EditorModule } from 'primeng/editor';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { InputMaskModule } from 'primeng/inputmask';
import { FormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { EmpresaListarModule } from '../../empresas/empresa-listar/empresa-listar.module';
import { CheckboxModule } from 'primeng/checkbox';
import { EmpresaEditarRoutingModule } from './empresa-editar-routing.module';
import { EmpresaEditarComponent } from './empresa-editar.component';
import { DialogModule } from 'primeng/dialog';
import { TreeModule } from 'primeng/tree';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { TributacaoAppModule } from '../../tributacao/tributacao.app.module';
import { UsuarioEmpresaAppModule } from '../../usuario-empresa/usuario-empresa.app.module';
import { PlanoContaEmpresaAppModule } from '../../plano-contas-empresa/plano-contas-empresa.app.module';


@NgModule({
 
  imports: [
    EmpresaEditarRoutingModule,
    CommonModule,
    ButtonModule,
    FormsModule,
    InputTextModule,
    InputTextareaModule,
    FileUploadModule,
    RippleModule,        
    ChipModule,
    TableModule,
    EditorModule,
    HttpClientModule,        
    TooltipModule,
    DividerModule,
    SplitButtonModule,
    ConfirmDialogModule,
    InputMaskModule,
    TabViewModule,
    EmpresaListarModule,
    CheckboxModule,
    DialogModule,
    TreeModule,
    InputSwitchModule,
    DropdownModule,
    FileUploadModule,
    ImageModule,
    UsuarioEmpresaAppModule,
    PlanoContaEmpresaAppModule,
    TributacaoAppModule
  ],
  providers: [
    ConfirmationService
  ],
  declarations: [
    EmpresaEditarComponent
  ]
})
export class EmpresaEditarModule { }
